import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const box = {
	backgroundColor: "#e0f7fa",
	border: "2px solid #59c3d8",
	borderRadius: 16,
	padding: "12px",
};
const h3 = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 14,
	fontWeight: 700,
	textTransform: "uppercase",
	marginBottom: 8,
	color: "#007a8d",
};
const p = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 13,
	color: "#444",
	margin: 0,
};
const ul = { paddingLeft: 0, margin: 0 };

// Template94: Aeropuertos NY (guia-ny Airports). Contenido desde page.
const Template94 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText =
		page?.texts?.[0]?.content ?? "Cómo llegar desde los aeropuertos de NY";
	const introText = page?.texts?.[1]?.content;
	const jfkTitle = page?.texts?.[2]?.content;
	const jfkListHtml = page?.texts?.[3]?.content;
	const ewrTitle = page?.texts?.[4]?.content;
	const ewrListHtml = page?.texts?.[5]?.content;
	const lgaTitle = page?.texts?.[6]?.content;
	const lgaListHtml = page?.texts?.[7]?.content;
	const sabiasQueHtml = page?.texts?.[8]?.content;
	const consejoTitle = page?.texts?.[9]?.content ?? "💡 Consejo";
	const consejoHtml = page?.texts?.[10]?.content;

	const sticker1 =
		getImageSrc("jfk") ||
		getImageSrc("narita-sticker") ||
		getImageSrc("airport-sticker");
	const sticker2 = getImageSrc("taxi");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				fontFamily: fontFamily || '"Poppins", sans-serif',
				"& *": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</div>
			{introText && (
				<div data-block-id="text-1" style={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<p style={p}>{introText}</p>
				</div>
			)}
			<div
				style={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 10,
					position: "relative",
					fontSize: 13,
				}}
			>
				{jfkTitle && (
					<div data-block-id="text-2" style={box}>
						<h3 style={{ ...h3, marginTop: 0 }}>{jfkTitle}</h3>
						{jfkListHtml && (
							<div
								style={ul}
								dangerouslySetInnerHTML={{ __html: jfkListHtml }}
							/>
						)}
					</div>
				)}
				{ewrTitle && (
					<div data-block-id="text-3" style={box}>
						<h3 style={{ ...h3, marginTop: 0 }}>{ewrTitle}</h3>
						{ewrListHtml && (
							<div
								style={ul}
								dangerouslySetInnerHTML={{ __html: ewrListHtml }}
							/>
						)}
					</div>
				)}
				{lgaTitle && (
					<div data-block-id="text-4" style={box}>
						<h3 style={{ ...h3, marginTop: 0 }}>{lgaTitle}</h3>
						{lgaListHtml && (
							<div
								style={ul}
								dangerouslySetInnerHTML={{ __html: lgaListHtml }}
							/>
						)}
					</div>
				)}
				{sabiasQueHtml && (
					<div
						data-block-id="text-5"
						style={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: 12,
							padding: "12px 14px",
							fontSize: 12,
						}}
					>
						<div dangerouslySetInnerHTML={{ __html: sabiasQueHtml }} />
					</div>
				)}
				{sticker1 && (
					<img
						src={sticker1}
						alt=""
						style={{
							width: isSmallScreen ? 90 : 100,
							position: "absolute",
							top: isSmallScreen ? -40 : 40,
							right: -10,
						}}
					/>
				)}
				{sticker2 && (
					<img
						src={sticker2}
						alt=""
						style={{
							width: 110,
							position: "absolute",
							bottom: isSmallScreen ? -40 : 60,
							right: -10,
						}}
					/>
				)}
				{consejoHtml && (
					<div
						data-block-id="text-6"
						style={{
							backgroundColor: "#e0f7fa",
							border: "2px solid #59c3d8",
							borderRadius: 16,
							padding: "16px",
							fontSize: 12,
							color: "#444",
						}}
					>
						{consejoTitle && (
							<h4
								style={{
									marginTop: 0,
									marginBottom: 8,
									fontSize: 13,
									color: "#007a8d",
									fontWeight: 700,
									textTransform: "uppercase",
								}}
							>
								{consejoTitle}
							</h4>
						)}
						<div dangerouslySetInnerHTML={{ __html: consejoHtml }} />
					</div>
				)}
			</div>
		</Box>
	);
};

export default Template94;
